import React from 'react';
import * as Styled from './ProductDonationCount.styled';
/**
 * Displays the number of items donated per the number of items purchased
 */
var ProductDonationCount = function (_a) {
    var _b = _a.count, count = _b === void 0 ? 1 : _b;
    var displayCount = count === 1 ? 'One' : count;
    return (React.createElement(Styled.ProductDonationCount, null,
        displayCount,
        " Purchased = ",
        displayCount,
        " Donated",
        count === 1 ? '™' : ''));
};
export default ProductDonationCount;
